import { call, put } from 'redux-saga/effects'
import { getUserSuccess } from 'redux/user/reducer'
import { IUser } from 'redux/user/types'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { onOpenNotification } from 'redux/notification/reducer'
import { otpDisableFailure, otpDisableSuccess } from 'redux/authForm/reducer'

export function* otpDisableSaga() {
	try {
		const response: {
			message: string
			data: { user: IUser }
		} = yield call(apiMiddleware, {
			url: app_config.services.otpDisable,
			method: 'POST',
		})

		yield put(getUserSuccess(response.data.user))
		yield put(otpDisableSuccess())

		yield put(
			onOpenNotification({
				message: response.message,
				notificationType: 'success',
			})
		)
	} catch (e) {
		yield put(otpDisableFailure())

		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)
	}
}
